const article = {
  id: 3,
  category: "IFRS",
  title: "IFRS 18 : Tout ce que vous devez savoir pour préparer vos états financiers 2027",
  text: "La nouvelle norme IFRS 18 remplace IAS 1 et transforme la présentation des comptes. Nos conseils pour une transition réussie.",
  link: "/articles/ifrs-18-nouveautes-etats-financiers-2027",
  date: "Juillet 2025",
  highlight: "Anticipez dès maintenant avec notre guide pratique"
};

export default article;
